import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_AUTHORIZATION'),
  ...asyncTypes('CREATE_AUTHORIZATION'),
  ...asyncTypes('UPDATE_AUTHORIZATION_STATUS')
};

export default TYPES;
